// #Stories Devkrest

import { AdamAwanyImg, ChargeawayStoryImg, CozmoRobotIconImg, Cyrus, GlowyCoverImg, IconFlagAustralia, IconFlagCan, IconFlagIndia, IconFlagSA, IconFlagUsa, Janis, Lincoln, Lower6CoverStoryImg, Robb, Ryan, Sasha, SwoopTeamImg, Tanvi } from "@/lib/images";
import { StaticImageData } from "next/image";

// Heading
export const Heading_Section_Stories_Devkrest = {
    heading: "Stories That Built Devkrest"
}

// Sub Heading
export const Sub_Heading_Section_Stories_Devkrest = {
    from_startups: "From startups to industry leaders, our clients trust us to bring their ideas to life. See how Devkrest helped teams streamline operations, boost engagement, and scale with confidence.",
    // streamline : " streamline operations, boost engagement, and scale with confidence."
}

// Testimonial Card Section 

export const Text_Testimonial_Review_Card_Stories_Devkrest = {
    heading: "Winning Hearts & Trust",
    sub_heading: "We don’t just build software—we build trust. Devkrest ensures your platforms run smoothly, stay scalable, and deliver high performance so your users stay confident and connected every step of the way."
}

interface ITestimonialReviewCardStoriesDevkrest {
    img: StaticImageData;
    name: string;
    flag: StaticImageData;
    company_name: string;
    review: string;
}

export const Testimonial_Review_Card_Stories_Devkrest: ITestimonialReviewCardStoriesDevkrest[] = [
    {
        img: AdamAwanyImg,
        name: "Adam Awany",
        flag: IconFlagUsa,
        company_name: "Cozmo Health",
        review: "I recently had the pleasure of working with Devkrest on the development of our health insurance app, and I couldn't be more impressed with the results. From start to finish, their dedication, expertise, and professionalism were evident, making the entire process smooth and efficient. We will without a doubt be a repeat customer. Thanks again!"
    },
    {
        img: Cyrus,
        name: "Cyrus Rafizadeh",
        flag: IconFlagAustralia,
        company_name: "ChargeAway (EV Charger)",
        review: "Our vision for ChargeAway was clear, but turning it into a functional, user-friendly platform was the real challenge. That’s where Devkrest came in—and they absolutely nailed it. From designing smooth user journeys to building a reliable backend that supports real-time charging data, they handled everything with care and precision. The end result is a product we’re proud to launch in the Australian market. They’ve been more than just a dev team—they’ve been true partners in this journey."
    },
    {
        img: Ryan,
        name: "Ryan Hendrix",
        flag: IconFlagUsa,
        company_name: "CaloriePal (Healthcare)",
        review: "Kaival has delivered a stable mobile app that enhances the client's user engagement, retention, and satisfaction. The team is communicative and delivers on time. The client is impressed with the team's expertise in cutting-edge technologies. Overall, it has been a positive experience."
    },
    {
        img: Tanvi,
        name: "Tanvi Mehta",
        flag: IconFlagIndia,
        company_name: "Glowy App (Skincare)",
        review: "It has been a great experience working with Kaival and Lakhan. They understood the application well and the final product is amazing. The app is seamless, and the features are exactly what I needed. The product was delivered timely. Great job by the Devkrest team!"
    },
    {
        img: Lincoln,
        name: "Lincoln G.",
        flag: IconFlagSA,
        company_name: "Vodacomm (Telecom)",
        review: "We had been using a pretty limited internal auditing system that just couldn’t keep up with the way our teams operate at Vodacom South Africa. When we brought Devkrest on board, things changed quickly. They took the time to understand our environment and built a solution that’s not only easy to use but actually improves how we manage audits. The difference has been clear from day one—efficient, reliable, and built exactly for what we need."
    },
    {
        img: Sasha,
        name: "Sasha Dejong",
        flag: IconFlagUsa,
        company_name: "AtMyCasa App (Social)",
        review: "Working with Devkrest has been a breath of fresh air for us. After a terrible experience with a previous team that left our app in a mess, we were honestly hesitant to trust again. But these guys came in, understood exactly what went wrong, and rebuilt AtMyCasa from the ground up with care and skill. It finally feels like the app we always imagined. Can't thank them enough—they've restored both the product and our faith in the process."
    },
    {
        img: Robb,
        name: "Robb Odell",
        flag: IconFlagUsa,
        company_name: "Bobber BioTech (Biotech)",
        review: "We initially had our website built by another team, but it ended up feeling too plain and didn’t really reflect who we are as a company. Then we found Devkrest—and the difference was night and day. They took the time to understand our brand and transformed our site into something we’re genuinely proud of. It’s professional, modern, and finally feels like us. The entire process was smooth, and the team was a pleasure to work with."
    },
    {
        img: Janis,
        name: "Janis Tiltins",
        flag: IconFlagCan,
        company_name: "Lavanest (Interior Design)",
        review: "As someone focused on design and aesthetics, I needed a website that truly reflected the style and quality of my interior design work. Devkrest understood that from day one. They didn’t just build a site—they brought my portfolio to life in a way that feels clean, modern, and completely aligned with my brand. The attention to detail, the flow, the visuals—everything just works. I finally have a digital space that does justice to my work."
    },

]

// Testimonial Card Section  >  Company & Team Review Cards 

interface ITestimonialCompanyTeamReviewCardStoriesDevkrest {
    id: string;
    company: string;
    logo?: StaticImageData;
    review?: string;
    team_image?: StaticImageData;
    read_more_url?: string;
}

export const Testimonial_Company_Team_Review_Card_Stories_Devkrest: ITestimonialCompanyTeamReviewCardStoriesDevkrest[] = [
    {
        id: "1",
        company: "Cozmo Gearz",
        logo: CozmoRobotIconImg,
        review: "Cozmo Gearz transformed how health insurance agents work. Our intelligent CRM system streamlined the entire quoting process, making it effortless for agents to find the perfect plan for each customer's unique needs. The result? A 40% boost in revenue and significantly improved customer satisfaction.",
        read_more_url: "/case-studies/custom-crm-health-insurance"
    },
    {
        id: "2",
        company: "Cozmo Plan Tool",
        team_image: SwoopTeamImg,
        read_more_url: "/case-studies/ai-based-insurance-plan-finder-solution",
    },
    {
        id: "3",
        company: "Chargeaway",
        team_image: ChargeawayStoryImg,
        read_more_url: "/case-studies/ev-charging-solution",
    },
    {
        id: "4",
        company: "CaloriePal",
        team_image: Lower6CoverStoryImg,
        read_more_url: "/case-studies/vision-ai-ml-recognition-mobile-app",
    },
    {
        id: "5",
        company: "Glowy",
        team_image: GlowyCoverImg,
        read_more_url: "/case-studies/skincare-routine-mobile-app",
    },
]


